import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["price", "frequency", "monthlyButton", "annualButton", "toggle"]

  static values = {
    monthlyPrice: String,
    annualPrice: String,
    perMonth: String,
    perYear: String,
  }

  declare readonly priceTarget: HTMLElement
  declare readonly frequencyTarget: HTMLElement
  declare readonly monthlyButtonTarget: HTMLElement
  declare readonly annualButtonTarget: HTMLElement
  declare readonly toggleTarget: HTMLElement
  declare readonly monthlyPriceValue: string
  declare readonly annualPriceValue: string
  declare readonly perMonthValue: string
  declare readonly perYearValue: string

  switch(e: Event) {
    e.preventDefault()

    const isMonthly = (e.currentTarget as HTMLElement).dataset.value === "monthly"

    this.priceTarget.textContent = isMonthly ? this.monthlyPriceValue : this.annualPriceValue
    this.frequencyTarget.textContent = isMonthly ? this.perMonthValue : this.perYearValue
    this.toggleTarget.dataset.active = isMonthly ? "monthly" : "annual"
    this.monthlyButtonTarget.setAttribute("aria-pressed", String(isMonthly))
    this.annualButtonTarget.setAttribute("aria-pressed", String(!isMonthly))

    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.priceTarget.animate(
        [
          { opacity: 0.35, transform: "translateY(4px)" },
          { opacity: 1, transform: "translateY(0)" },
        ],
        { duration: 220, easing: "cubic-bezier(0.22, 1, 0.36, 1)" },
      )
    }
  }
}
